module.exports = {
  GetRequest: "GET"
};